import useRemoteAssets from "../utils/useRemoteAssets";
import useSplashScreen from "../hooks/useSplashScreen";

export default function SplashScreen() {
  

  const ASSETS = useRemoteAssets();
  const { loading, error } = useSplashScreen();

  if (!ASSETS) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-10 h-10 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center w-full h-screen gap-6">
      <div className="flex flex-row items-center gap-3">
        <img
          src={ASSETS.logo}
          alt="logo"
          className="h-[70px]"
        />

        <h1 className="text-4xl font-bold text-red-600 md:text-6xl">
          Ambit
        </h1>
      </div>

      {loading && (
        <div className="w-8 h-8 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      )}

      {error && (
        <p className="text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
}